import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-owners',
    templateUrl: './owners.component.html',
    styleUrls: ['./owners.component.scss'],
    standalone: false
})
export class OwnersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
